import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { ActivityComponent } from './activity/activity.component';
import { CircularComponent } from './circular/circular.component';
import { NoticeBoardComponent } from './notice-board/notice-board.component';
import { HolidayListComponent } from './holiday-list/holiday-list.component';
import { PhotoGalaryComponent } from './photo-galary/photo-galary.component';
import { VideoGalaryComponent } from './video-galary/video-galary.component';
import { TcComponent } from './tc/tc.component';
import { AdsSliderComponent } from './ads-slider/ads-slider.component';
import { FacilityComponent } from './facility/facility.component';
import { SchoolInformationComponent } from './school-information/school-information.component';
import { CareerComponent } from './career/career.component';
import { SchoolNewsComponent } from './school-news/school-news.component';
import { AcademicComponent } from './academic/academic.component';



const routes: Routes = [
  { 
    path: '', 
    component: AdminComponent,
    children: [
      { path: 'activity', component:ActivityComponent, pathMatch: 'full'},
      { path: 'circular', component:CircularComponent, pathMatch: 'full'},
      { path: 'noticeboard', component:NoticeBoardComponent, pathMatch: 'full'},
      { path: 'holidaylist', component:HolidayListComponent, pathMatch: 'full'},
      { path: 'photogalary', component:PhotoGalaryComponent, pathMatch: 'full'},
      { path: 'videogalary', component:VideoGalaryComponent, pathMatch: 'full'},
      { path: 'tc', component:TcComponent, pathMatch: 'full'},
      { path: 'adsslider', component:AdsSliderComponent, pathMatch: 'full'},
      { path: 'facility', component:FacilityComponent, pathMatch: 'full'},
      { path: 'schoolinformation', component:SchoolInformationComponent, pathMatch: 'full'},
      { path: 'career', component:CareerComponent, pathMatch: 'full'},
      { path: 'schoolnews', component:SchoolNewsComponent, pathMatch: 'full'},
      { path: 'academic', component:AcademicComponent, pathMatch: 'full'},
      
    ]
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministrationRoutingModule { }
